var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M87.021 74.258c-9.644-12.292-12.166-32.201-12.824-42.302-.035-.53-.231-2.353-.231-2.775C73.966 13.2 60.68.237 44.208.02L44.205 0c-.068 0-.135.01-.206.01-.068 0-.135-.01-.206-.01l-.002.02C27.321.237 14.033 13.2 14.033 29.18c0 .423-.196 2.247-.23 2.776-.657 10.1-3.18 30.01-12.823 42.302-2.525 3.216.162 7.798 4.274 7.114l.283-.048s2.99-1.133 10.056 3.94c5.315 3.816 9.964-2.906 20.426.383.856.384 2.183.972 2.778 1.258 1.738.829 3.409 1.147 5.086 1.088.04.002.077-.002.116 0 .04-.002.08.002.119 0 1.677.059 3.348-.26 5.084-1.088.597-.286 1.924-.874 2.78-1.258 10.462-3.289 15.11 3.433 20.423-.383 7.067-5.073 10.057-3.94 10.057-3.94l.283.048c4.114.684 6.798-3.898 4.276-7.114",
    transform: "translate(5.556 5.556)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M50.667 42.667c.736 0 1.333.597 1.333 1.333s-.597 1.333-1.333 1.333h-12c-.737 0-1.334-.597-1.334-1.333s.597-1.333 1.334-1.333h12zM32.267 24c2.356 0 4.266 1.91 4.266 4.267 0 2.356-1.91 4.266-4.266 4.266-2.357 0-4.267-1.91-4.267-4.266C28 25.91 29.91 24 32.267 24zm25.6 0c2.356 0 4.266 1.91 4.266 4.267 0 2.356-1.91 4.266-4.266 4.266-2.357 0-4.267-1.91-4.267-4.266C53.6 25.91 55.51 24 57.867 24z",
    transform: "translate(5.556 5.556)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError2);
export default __webpack_public_path__ + "static/media/error-2.660a565d.svg";
export { ForwardRef as ReactComponent };